import { render, staticRenderFns } from "./ns-alert.vue?vue&type=template&id=6d1010f6&scoped=true&"
import script from "./ns-alert.vue?vue&type=script&lang=js&"
export * from "./ns-alert.vue?vue&type=script&lang=js&"
import style0 from "./ns-alert.vue?vue&type=style&index=0&id=6d1010f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1010f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1010f6')) {
      api.createRecord('6d1010f6', component.options)
    } else {
      api.reload('6d1010f6', component.options)
    }
    module.hot.accept("./ns-alert.vue?vue&type=template&id=6d1010f6&scoped=true&", function () {
      api.rerender('6d1010f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-app-elements/src/ns-alert-vue/ns-alert.vue"
export default component.exports